import React from "react";

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import GlobalCta from "../../components/global/GlobalCta";
import PageHero from "../../components/global/PageHero";
import ServiceOverview from "../../components/global/ServiceOverview";
import ServiceFeatures from "../../components/global/ServiceFeatures";

const OVERVIEW = [
    "We help you stay ahead as we build the next-generation website for your business. We are a reputed UI/UX design agency offering a full range of design and development services.",
    "Your business will scale heights as we cater rich, responsive UI/UX design that gives your website a professional appearance, integrating CMS and e-commerce features with the latest technologies for a hassle-free user experience.",
];

const FEATURES = [
    { title: "Lead generation", text: "Skilled experts in UI/UX design, e-commerce sites, custom web development and Android, iOS & hybrid mobile apps — built with an improved link structure that lets users navigate easily, boosting engagement and generating leads." },
    { title: "High-quality work", text: "We concentrate on developing user-friendly websites, add a contact form so users can connect with your brand, and craft quality content for the products we build to lift your business to the next level." },
    { title: "Deliver user experience", text: "We cater UX/UI design solutions to customers globally, considering individual user behaviours, using the latest technologies so applications work across all mobile and computing devices." },
    { title: "Increased brand visibility", text: "Our developers work to current market trends to give your business a competitive edge, building interactive UI/UX designs that attract authentic traffic and are refined through user feedback and our technical expertise." },
    { title: "Technology expertise", text: "We work with open-source web applications, custom PHP applications and CMS platforms (Joomla, WordPress, osCommerce, Drupal), and deliver e-commerce & shopping-cart solutions using Magento, WooCommerce and Shopify." },
];

const FEATURES_2 = [
    { title: "UI/UX built around your model", text: "We deliver the best UI/UX design services tailored to your specific business model." },
    { title: "A personalised experience", text: "We embed eye-catching design elements — videos, podcasts, images, infographics and more — to give the end-user a personalised experience." },
    { title: "UI/UX audits", text: "We audit your website to optimise UI/UX and enhance overall performance." },
    { title: "A trusted, global firm", text: "We are a trusted firm with clients across India, Australia, the UK, Canada and the USA." },
];

export default function WebsiteDesignAndDevelopment() {
    return (
        <>
            <Header />

            <main>
                <PageHero eyebrow="Web Development" title="Website Design & Development" eyebrowAs="span">
                    We offer custom website design and development services featuring emerging trends — maintaining supreme quality to help you meet your business objectives. Redesign your website with our UI/UX web designers.
                </PageHero>
                <ServiceOverview paragraphs={OVERVIEW} />
                <ServiceFeatures items={FEATURES} />
                <ServiceFeatures eyebrow="Why us" heading="Why work with Kudosta" items={FEATURES_2} />
            </main>

            <GlobalCta />

            <Footer />
        </>
    );
}
